import { Link, Typography } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";
import InfoCard from "../../../../../components/InfoCard";

const InfoBlock = () => {
  const {t} = useTranslation();

  return (
    <InfoCard title={t("CLP_WhatIsAChecklist")}>
      <Typography
        variant="body2"
        gutterBottom
      >
        {t('CLP_Checklist_is_generated_based')} {" "}
        <Link component={NavLink} exact to="/documentation">
          {t("CLP_FAR_ConsultTheDocumentation")}.
        </Link>
      </Typography>
    </InfoCard>
  )
}

export default InfoBlock
